import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  bgColor: '#6783ff',
  color: '#fff'
};
